import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { Col, Form, Input, Modal, Row, Select, message } from 'antd';
import {
  CalendarOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  MinusOutlined,
  MobileOutlined,
  PhoneOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';
import API from "../scripts/api";
import DatePicker from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";
import { Constants } from "../scripts/settings";

class LogisticsScheduleForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: [],
            countries: [],
            cities: [],
            neighborhoods: [],
            loading: false,
            loadingCities: false,
            loadingNeighborhoods: false,
            editMode: false,
        };

        this.formRef = React.createRef();
    }


    handleSubmit = () => {
        this.formRef.current
            .validateFields()
            .then(values => {
                if (values.send_date) {
                    values.send_date = moment(
                        `${values.send_date.year}-${values.send_date.month}-${values.send_date.day}`,
                        Constants.jDateFormat
                    ).format(Constants.dateFormat);
                }

                this.props.onSubmit(values);
            })
            .catch(errorInfo => {
                // خطاهای ولیدیشن فیلدها در errorInfo.errorFields قرار دارند
                if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
                    // نمایش اولین خطای فرم به کاربر
                    const firstError = errorInfo.errorFields[0].errors[0];
                    message.error(firstError || 'لطفاً فیلدهای الزامی را به درستی تکمیل کنید.');
                } else {
                    // در صورت وجود خطای پیش‌بینی‌نشده دیگر
                    message.error('خطایی در اعتبارسنجی فرم رخ داده است.');
                }
                console.error('Validation Failed:', errorInfo);
            });
    };

    // handleSubmit = () => {
    //     this.formRef.current.validateFields().then(values => {

    //     if (values.send_date){
    //         values.send_date = moment(
    //         `${values.send_date.year}-${values.send_date.month}-${values.send_date.day}`,
    //         Constants.jDateFormat
    //         ).format(Constants.dateFormat);
    //     }
       

    //         this.props.onSubmit(values);
    //     });
    // }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
        this.setState({
            fileList: [],
            cities: [],
            neighborhoods: [],
        });
    }

    handleDidMount = async (data = {}) => {
        const cloneData = cloneDeep(data);
        await this.getCountries();

        // اگر رکورد قبلاً مقدار داشته باشد، شهر/محله هم لود شوند
        if (cloneData.country_id) {
            await this.getCities(cloneData.country_id);
        }
        if (cloneData.city_id) {
            await this.getNeighborhoods(cloneData.city_id);
        }
        if (cloneData.send_date) {
              const send_date = moment(cloneData.send_date);
        
              cloneData.send_date = {
                day: send_date.jDate(),
                month: send_date.jMonth() + 1,
                year: send_date.jYear(),
              };
        }

        this.formRef.current.setFieldsValue(cloneData);
        this.setState({ editMode: !!cloneData.id });
    }

    getCountries = (params = {}) => {
        this.setState({ loading: true });

        return API.country.list(params)
            .then((result) => {
                this.setState({
                    loading: false,
                    countries: result.data || [],
                });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    getCities = (country_id) => {
        this.setState({ loadingCities: true });

        return API.city.list( country_id )
            .then((result) => {
                this.setState({
                    loadingCities: false,
                    cities: result.data || [],
                });
            })
            .catch(() => {
                this.setState({ loadingCities: false });
            });
    };

    getNeighborhoods = (city_id) => {
        this.setState({ loadingNeighborhoods: true });

        return API.neighborhood.list( city_id )
            .then((result) => {
                this.setState({
                    loadingNeighborhoods: false,
                    neighborhoods: result.data || [],
                });
            })
            .catch(() => {
                this.setState({ loadingNeighborhoods: false });
            });
    };

    handleCountryChange = async (country_id) => {
        this.formRef.current.setFieldsValue({
            city_id: undefined,
            neighborhood_id: undefined,
        });

        this.setState({
            cities: [],
            neighborhoods: [],
        });

        if (country_id) {
            await this.getCities(country_id);
        }
    };

    handleCityChange = async (city_id) => {
        this.formRef.current.setFieldsValue({
            neighborhood_id: undefined,
        });

        this.setState({
            neighborhoods: [],
        });

        if (city_id) {
            await this.getNeighborhoods(city_id);
        }
    };
  handleChangeDate = (date, obj) => {
    const state = {};
    state[obj] = date;
    this.formRef.current.setFieldsValue(state);
  };
    render() {
        const { onCancel, submitting, visible } = this.props;
        const {
            fileList,
            editMode,
            countries,
            cities,
            neighborhoods,
            loadingCities,
            loadingNeighborhoods
        } = this.state;
    const DatePickerInput = ({ ref }, name) => {
      const date = this.formRef.current
        ? this.formRef.current.getFieldValue(name)
        : null;
      return (
        <Input
          value={date ? `${date.year}-${date.month}-${date.day}` : date}
          prefix={<CalendarOutlined />}
          placeholder={Resources.choose}
          ref={ref}
          readOnly
        />
      );
    };

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}
            >
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="country_id"
                                label={Resources.country}
                                rules={Rules.required}
                            >
                                <Select
                                    placeholder={Resources.choose}
                                    onChange={this.handleCountryChange}
                                    allowClear
                                >
                                    {countries.map(country => (
                                        <Select.Option key={country.id} value={country.id}>
                                            {country.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="city_id"
                                label={Resources.city}
                                rules={Rules.required}
                            >
                                <Select
                                    placeholder={Resources.choose}
                                    onChange={this.handleCityChange}
                                    allowClear
                                    disabled={!cities.length && !loadingCities}
                                    loading={loadingCities}
                                >
                                    {cities.map(city => (
                                        <Select.Option key={city.id} value={city.id}>
                                            {city.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="neighborhood_id"
                                label={Resources.neighborhood}
                            >
                                <Select
                                    placeholder={Resources.choose}
                                    allowClear
                                    disabled={!neighborhoods.length && !loadingNeighborhoods}
                                    loading={loadingNeighborhoods}
                                >
                                    {neighborhoods.map(neighborhood => (
                                        <Select.Option key={neighborhood.id} value={neighborhood.id}>
                                            {neighborhood.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                          <Col xs={24} md={12}>
                                        <Form.Item name="send_date" label={Resources.date}>
                                          <DatePicker
                                            locale="fa"
                                            onChange={(value) =>
                                              this.handleChangeDate(value, "send_date")
                                            }
                                            renderInput={(ref) => DatePickerInput(ref, "send_date")}
                                            shouldHighlightWeekends
                                          />
                                        </Form.Item>
                                      </Col>

                    </Row>
                </Form>
            </Modal>
        );
    }
}

export default LogisticsScheduleForm;
